import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "px-4 sticky flex items-center",
  style: {"z-index":"50"},
  id: "product-title-nav"
}
const _hoisted_2 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.5rem","height":"1.5rem"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  style: {"fill":"currentcolor"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "opacity-0 font-semibold left-1/2 -translate-x-1/2 absolute only-1-lines min-w-64 text-center" }
const _hoisted_6 = { class: "grid grid-cols-12 gap-4" }
const _hoisted_7 = { class: "col-span-12 md:col-span-5 w-full pl-8 overflow-auto max-h-full main-image-container relative" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 9V3H15",
    stroke: "#171717",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-primary"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M3 15V21H9",
    stroke: "#171717",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-primary"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21 3L13.5 10.5",
    stroke: "#171717",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-primary"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.5 13.5L3 21",
    stroke: "#171717",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    class: "stroke-primary"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "col-span-12 md:col-span-7 flex flex-col product-modal__right" }
const _hoisted_12 = { class: "px-4 pb-4" }
const _hoisted_13 = {
  class: "text-xl font-bold",
  id: "product-modal__product-name"
}
const _hoisted_14 = { class: "text-gray-500 max-w-full mb-4 mt-2 text-sm" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col gap-1"
}
const _hoisted_16 = { class: "font-bold text-sm" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "De: ", -1)
const _hoisted_18 = { class: "line-through text-red-400" }
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-md" }, "Por: ", -1)
const _hoisted_21 = { class: "text-success" }
const _hoisted_22 = {
  key: 1,
  class: "font-bold text-neutral-700"
}
const _hoisted_23 = {
  class: "p-4 sticky top-0 z-20 product-modal__right__variation__header",
  style: {"background":"#F9F9F9"}
}
const _hoisted_24 = { class: "flex justify-between items-center" }
const _hoisted_25 = { class: "font-semibold" }
const _hoisted_26 = {
  key: 0,
  class: "relative"
}
const _hoisted_27 = { class: "h-4 w-4 rounded-full relative z-10 bg-success" }
const _hoisted_28 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1rem","height":"1rem","z-index":"10"}
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 1,
  class: "text-white font-bold bg-black p-2 py-1 rounded-lg text-xs"
}
const _hoisted_32 = { class: "flex items-center gap-2 pt-1 text-xs text-gray-500" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 16v-4" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 8h.01" })
], -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "grid grid-cols-12 gap-4 p-4" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 1,
  class: "px-2 py-0.5 bg-red-500 rounded-full text-white text-[10px] flex justify-center items-center"
}
const _hoisted_42 = {
  class: "p-4 sticky top-0 product-modal__addon-groups__addon-group__header",
  style: {"background":"#F9F9F9"}
}
const _hoisted_43 = { class: "flex items-center justify-between gap-2" }
const _hoisted_44 = { class: "font-semibold" }
const _hoisted_45 = {
  key: 0,
  class: "relative"
}
const _hoisted_46 = { class: "h-4 w-4 rounded-full relative z-10 bg-success" }
const _hoisted_47 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1rem","height":"1rem","z-index":"10"}
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("path", {
  d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = {
  key: 1,
  class: "text-white font-bold bg-black p-2 py-1 rounded-lg text-xs"
}
const _hoisted_51 = { class: "flex items-center gap-2 pt-1 text-xs text-gray-500" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 16v-4" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 8h.01" })
], -1)
const _hoisted_53 = { class: "flex items-center justify-between w-full" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  key: 2,
  class: "font-bold"
}
const _hoisted_59 = { class: "text-success" }
const _hoisted_60 = { class: "flex flex-col" }
const _hoisted_61 = { class: "flex items-center gap-3" }
const _hoisted_62 = ["src"]
const _hoisted_63 = { class: "text-sm font-semibold text-gray-700" }
const _hoisted_64 = {
  key: 0,
  class: "text-success text-xs font-bold font-inter"
}
const _hoisted_65 = { class: "flex gap-4 items-center bg-gray-100 p-1 px-3 rounded-full border border-gray-200" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14" })
], -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = { class: "w-4 text-center font-bold text-sm" }
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 5v14M5 12h14" })
], -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "p-4 border-t" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-semibold text-gray-700 mb-2" }, "Observações (opcional)", -1)
const _hoisted_75 = { class: "flex items-center gap-4 pt-4 fixed bottom-0 box-shadow sm:shadow-none sm:mt-5 right-0 left-0 rounded-tl-2xl rounded-tr-2xl sm:rounded-2xl justify-between px-8 py-4 product-modal__add-to-cart bg-white border-t sm:border-none" }
const _hoisted_76 = { class: "flex gap-6 items-center bg-gray-100 p-2 px-6 rounded-full" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5 12h14" })
], -1)
const _hoisted_78 = [
  _hoisted_77
]
const _hoisted_79 = { class: "text-lg font-bold min-w-[1rem] text-center" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12 5v14M5 12h14" })
], -1)
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = ["disabled"]
const _hoisted_83 = { class: "text-left" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("p", { class: "text-[10px] uppercase font-bold opacity-80" }, "Adicionar ao carrinho", -1)
const _hoisted_85 = { class: "text-lg font-bold" }
const _hoisted_86 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"1.8rem","height":"1.8rem"}
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_88 = [
  _hoisted_87
]
const _hoisted_89 = { class: "h-full flex flex-col bg-black/95" }
const _hoisted_90 = {
  viewBox: "0 0 24 24",
  role: "presentation",
  style: {"width":"2rem","height":"2rem"}
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = { class: "flex-1 flex flex-col justify-center items-center p-8 gap-6" }
const _hoisted_94 = ["src"]
const _hoisted_95 = { class: "max-w-2xl w-full text-white text-center" }
const _hoisted_96 = { class: "text-2xl font-bold mb-2" }
const _hoisted_97 = { class: "text-sm opacity-80" }

import MyModal from './MyModal.vue';
import { ref, watch, computed } from 'vue';
import { cart, apiBaseUrl, organization, organizationSettings } from '@/global/state/GlobalState';
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductModal',
  props: {
    product: {},
    toggleModal: { type: Function },
    isOpen: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const quantity = ref<number>(1)
const selectedVariants = ref<Record<number, number[]>>({}) // groupIndex -> variantIds
const selectedAddOns = ref<Record<number, number>>({}) // addonId -> quantity
const notes = ref<string>('')

const knowMore = ref<boolean>(false)
const isAmplifyImageModalOpen = ref<boolean>(false)
const toast = useToast()

function displayDescription(description?: string){
    if(!description) return ''
    if(description.length > 184 && !knowMore.value){
        return description.substring(0, 164) + '...'
    }
    return description
}

function handleModalScroll(e: any){
    const productTitleNav = document.querySelector('#product-title-nav') as HTMLElement
    const modalProductTitle = document.querySelector('#product-modal__product-name') as HTMLElement
    if(productTitleNav && modalProductTitle){
        if(e.target.scrollTop >= modalProductTitle.offsetTop){
            productTitleNav.classList.add('show-title')
        } else{
            productTitleNav.classList.remove('show-title')
        }
    }
}

// Reset state when product changes
watch(() => props.product, () => {
    quantity.value = 1
    selectedVariants.value = {}
    selectedAddOns.value = {}
    notes.value = ''
    knowMore.value = false
}, { deep: true })

const isVariantSelected = (variantId: number) => {
    return Object.values(selectedVariants.value).some(ids => ids.includes(variantId))
}

const toggleVariantSelection = (group: any, variant: any) => {
    const groupId = group.id
    if (!selectedVariants.value[groupId]) {
        selectedVariants.value[groupId] = []
    }

    const currentSelection = selectedVariants.value[groupId]
    const isSelected = currentSelection.includes(variant.id)

    if (isSelected) {
        selectedVariants.value[groupId] = currentSelection.filter(id => id !== variant.id)
    } else {
        if (group.type === 'single' || group.max === 1) {
            selectedVariants.value[groupId] = [variant.id]
        } else {
            if (!group.max || currentSelection.length < group.max) {
                selectedVariants.value[groupId].push(variant.id)
            } else {
                toast.warning(`Máximo de ${group.max} opções permitido`)
            }
        }
    }
}

const getAddOnQuantity = (addonId: number) => selectedAddOns.value[addonId] || 0

const getAddOnGroupCurrentQuantity = (groupId: number) => {
    const group = props.product.addOnGroups.find((g: any) => g.id === groupId)
    if (!group) return 0
    return group.addOns.reduce((acc: number, addon: any) => acc + getAddOnQuantity(addon.id), 0)
}

const updateAddOnQuantity = (group: any, addon: any, delta: number) => {
    const currentQty = getAddOnQuantity(addon.id)
    const newQty = currentQty + delta
    
    if (newQty < 0) return

    const totalInGroup = getAddOnGroupCurrentQuantity(group.id)
    if (delta > 0 && group.max && totalInGroup >= group.max) {
        toast.warning(`Máximo de ${group.max} itens permitido para ${group.name}`)
        return
    }

    if (newQty === 0) {
        delete selectedAddOns.value[addon.id]
    } else {
        selectedAddOns.value[addon.id] = newQty
    }
}

const isVariantGroupFulfilled = (group: any) => {
    const selected = selectedVariants.value[group.id] || []
    return selected.length >= (group.min || (group.isRequired ? 1 : 0))
}

const isAddOnGroupFulfilled = (group: any) => {
    const total = getAddOnGroupCurrentQuantity(group.id)
    return total >= (group.min || (group.isRequired ? 1 : 0))
}

const canAddToCart = computed(() => {
    if (!props.product) return false
    
    const variantGroupsOk = props.product.variantGroups?.every(isVariantGroupFulfilled) ?? true
    const addOnGroupsOk = props.product.addOnGroups?.every(isAddOnGroupFulfilled) ?? true
    
    return variantGroupsOk && addOnGroupsOk && quantity.value > 0
})

const totalPrice = computed(() => {
    if (!props.product) return 0
    
    let basePrice = props.product.promoPrice || props.product.price
    let extras = 0

    // Add selected variants prices
    Object.values(selectedVariants.value).forEach(ids => {
        ids.forEach(id => {
            const variant = props.product.variantGroups.flatMap((g: any) => g.variants).find((v: any) => v.id === id)
            if (variant) extras += variant.price
        })
    })

    // Add selected addons prices
    Object.entries(selectedAddOns.value).forEach(([id, qty]) => {
        const addonId = parseInt(id)
        const addon = props.product.addOnGroups.flatMap((g: any) => g.addOns).find((a: any) => a.id === addonId)
        if (addon) extras += addon.price * qty
    })

    return (basePrice + extras) * quantity.value
})

function addToCart() {
    if (!canAddToCart.value) return

    // Format selection for the cart
    const cartItem = {
        ...props.product,
        cartId: Date.now() + Math.random(), // unique ID for item in cart
        quantity: quantity.value,
        selectedVariants: { ...selectedVariants.value },
        selectedAddOns: { ...selectedAddOns.value },
        notes: notes.value,
        totalPrice: totalPrice.value,
        unitPrice: totalPrice.value / quantity.value
    }

    cart.value.push(cartItem)
    toast.success('Produto adicionado!')
    props.toggleModal(false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MyModal, {
      width: '50rem',
      height: '38rem',
      isOpen: _ctx.isOpen,
      toggleModal: _ctx.toggleModal,
      zIndex: 200,
      id: 'product-modal'
    }, {
      default: _withCtx(() => [
        (_ctx.product?.name)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "font-inter relative product-modal overflow-auto pb-4 md:pb-0",
              onScroll: _cache[8] || (_cache[8] = ($event: any) => (handleModalScroll($event)))
            }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("button", {
                  class: "transition duration-200 hover:text-primary p-2 rounded-full box-shadow bg-white justify-self-start left-4",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(false)))
                }, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
                ]),
                _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.product.name), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("img", {
                      class: "rounded-xl h-60 w-full object-contain main-product-image",
                      src: _ctx.product.media?.length ? (_unref(apiBaseUrl) + '/storage/' + _ctx.product.media[0].path) : '/assets/no-image.png',
                      alt: "Imagem do produto",
                      onError: _cache[1] || (_cache[1] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                    }, null, 40, _hoisted_8),
                    _createElementVNode("button", {
                      class: "absolute top-4 right-4 box-shadow p-2 rounded-lg",
                      style: {"background":"rgba(255, 255, 255, 0.8)","z-index":"201"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (isAmplifyImageModalOpen.value = true))
                    }, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.product.name), 1),
                      _createElementVNode("p", _hoisted_14, [
                        _createTextVNode(_toDisplayString(displayDescription(_ctx.product.description as string)) + " ", 1),
                        (!knowMore.value && (_ctx.product.description?.length ?? 0) > 184)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (knowMore.value = true)),
                              class: "text-primary font-semibold uppercase underline"
                            }, "saiba mais"))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.product.promoPrice)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("p", _hoisted_16, [
                              _hoisted_17,
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.product.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                            ]),
                            _createElementVNode("p", _hoisted_19, [
                              _hoisted_20,
                              _createTextVNode(),
                              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.product.promoPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.product.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.variantGroups, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "product-modal__right__variation",
                        key: group.id
                      }, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("h6", _hoisted_25, _toDisplayString(group.name), 1),
                            (group.isRequired && isVariantGroupFulfilled(group))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_28, _hoisted_30))
                                  ])
                                ]))
                              : (group.isRequired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "obrigatório"))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            (group.min > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                  _createTextVNode("Selecione no mínimo " + _toDisplayString(group.min), 1),
                                  (group.max)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, " e no máximo " + _toDisplayString(group.max), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                  _createTextVNode("Opcional "),
                                  (group.max)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "(máximo " + _toDisplayString(group.max) + ")", 1))
                                    : _createCommentVNode("", true)
                                ]))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.variants, (variant) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: variant.id,
                              onClick: ($event: any) => (toggleVariantSelection(group, variant)),
                              class: _normalizeClass(["relative cursor-pointer px-2 py-2 rounded-2xl font-bold transition-colors duration-200 w-full col-span-4 flex justify-center items-center flex-col gap-2 border hover:border-primary", isVariantSelected(variant.id) ? 'border-success bg-success/5' : 'border-gray-200'])
                            }, [
                              (variant.media?.length)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _unref(apiBaseUrl) + '/storage/' + variant.media[0].path,
                                    class: "w-12 h-12 rounded-lg object-cover"
                                  }, null, 8, _hoisted_40))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", {
                                class: _normalizeClass(["text-center text-sm", isVariantSelected(variant.id) ? 'text-success' : ''])
                              }, _toDisplayString(variant.name), 3),
                              (variant.price > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, "+" + _toDisplayString(variant.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})), 1))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_39))
                          }), 128))
                        ])
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.addOnGroups, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "product-modal__addon-groups__addon-group",
                        key: group.id
                      }, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("h6", _hoisted_44, _toDisplayString(group.name), 1),
                            (group.isRequired && isAddOnGroupFulfilled(group))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    (_openBlock(), _createElementBlock("svg", _hoisted_47, _hoisted_49))
                                  ])
                                ]))
                              : (group.isRequired)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_50, "obrigatório"))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("div", _hoisted_53, [
                              (group.min > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_54, [
                                    _createTextVNode("Selecione no mínimo " + _toDisplayString(group.min), 1),
                                    (group.max)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_55, " e no máximo " + _toDisplayString(group.max), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_56, [
                                    _createTextVNode("Opcional "),
                                    (group.max)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_57, "(máximo " + _toDisplayString(group.max) + ")", 1))
                                      : _createCommentVNode("", true)
                                  ])),
                              (group.max)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_58, [
                                    _createElementVNode("span", _hoisted_59, _toDisplayString(getAddOnGroupCurrentQuantity(group.id)), 1),
                                    _createTextVNode("/" + _toDisplayString(group.max), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.addOns, (addon) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: addon.id,
                              class: "w-full flex items-center justify-between p-4 border-b last:border-0 hover:bg-gray-50 transition"
                            }, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("img", {
                                  class: "h-14 w-14 rounded-xl object-cover border",
                                  src: addon.media?.length ? (_unref(apiBaseUrl) + '/storage/' + addon.media[0].path) : '/assets/no-image.png',
                                  alt: "Complemento",
                                  onError: _cache[4] || (_cache[4] = ($event: any) => (($event.target as HTMLImageElement).src = '/assets/no-image.png'))
                                }, null, 40, _hoisted_62),
                                _createElementVNode("div", null, [
                                  _createElementVNode("h6", _hoisted_63, _toDisplayString(addon.name), 1),
                                  (addon.price > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, "+" + _toDisplayString(addon.price.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_65, [
                                _createElementVNode("button", {
                                  class: "text-gray-500 hover:text-red-500 transition",
                                  onClick: ($event: any) => (updateAddOnQuantity(group, addon, -1))
                                }, _hoisted_68, 8, _hoisted_66),
                                _createElementVNode("span", _hoisted_69, _toDisplayString(getAddOnQuantity(addon.id)), 1),
                                _createElementVNode("button", {
                                  class: "text-gray-500 hover:text-success transition",
                                  onClick: ($event: any) => (updateAddOnQuantity(group, addon, 1))
                                }, _hoisted_72, 8, _hoisted_70)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((notes).value = $event)),
                    placeholder: "Ex: Sem cebola, sem pimenta...",
                    class: "w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-primary resize-none",
                    rows: "3"
                  }, null, 512), [
                    [_vModelText, notes.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("button", {
                    class: "text-gray-600 hover:text-primary transition",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (quantity.value > 1 ? quantity.value-- : null))
                  }, _hoisted_78),
                  _createElementVNode("span", _hoisted_79, _toDisplayString(quantity.value), 1),
                  _createElementVNode("button", {
                    class: "text-gray-600 hover:text-primary transition",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (quantity.value++))
                  }, _hoisted_81)
                ]),
                _createElementVNode("button", {
                  disabled: !canAddToCart.value,
                  onClick: addToCart,
                  class: "flex-1 max-w-xs flex items-center justify-between p-4 rounded-2xl transition duration-200 font-inter box-shadow",
                  style: _normalizeStyle({background: canAddToCart.value ? _unref(organizationSettings).primaryColor || '#323232' : '#f5f5f5', color: canAddToCart.value ? '#fff' : '#949494'})
                }, [
                  _createElementVNode("div", _hoisted_83, [
                    _hoisted_84,
                    _createElementVNode("p", _hoisted_85, _toDisplayString(totalPrice.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'})), 1)
                  ]),
                  (_openBlock(), _createElementBlock("svg", _hoisted_86, _hoisted_88))
                ], 12, _hoisted_82)
              ])
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"]),
    _createVNode(MyModal, {
      width: '100%',
      height: '100%',
      id: 'amplify-image-modal',
      isOpen: isAmplifyImageModalOpen.value,
      toggleModal: (v) => isAmplifyImageModalOpen.value = v,
      zIndex: 201
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("button", {
            class: "p-4 text-white hover:text-primary transition absolute top-4 left-4",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (isAmplifyImageModalOpen.value = false))
          }, [
            (_openBlock(), _createElementBlock("svg", _hoisted_90, _hoisted_92))
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("img", {
              class: "max-h-[70vh] object-contain rounded-2xl",
              src: _ctx.product.media?.length ? (_unref(apiBaseUrl) + '/storage/' + _ctx.product.media[0].path) : '/assets/no-image.png',
              alt: "Produto"
            }, null, 8, _hoisted_94),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("h2", _hoisted_96, _toDisplayString(_ctx.product.name), 1),
              _createElementVNode("p", _hoisted_97, _toDisplayString(_ctx.product.description), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isOpen", "toggleModal"])
  ]))
}
}

})